/* Start Section umc_freshcap_hero_banner_wEWbAm */
document.addEventListener("DOMContentLoaded",function(){const videoPlayers=document.querySelectorAll("video-player");videoPlayers.forEach((player,index)=>{const video=player.querySelector("video");const transcript=player.querySelector(".video-transcript");if(video&&transcript){let transcriptId=transcript.id;if(!transcriptId){transcriptId=`video-transcript-${index+1}`;transcript.id=transcriptId;}
video.setAttribute("aria-describedby",transcriptId);const altText=video.getAttribute("alt")||video.getAttribute("aria-label")||"Video with transcript available.";video.setAttribute("aria-label",altText);video.setAttribute("alt",altText);if(!video.hasAttribute("tabindex")){video.setAttribute("tabindex","0");}}});});
/* End Section umc_freshcap_hero_banner_wEWbAm */
/* Start Section umc_freshcapvideo_tz3nzX */
document.addEventListener("DOMContentLoaded",function(){const videoPlayers=document.querySelectorAll("video-player");videoPlayers.forEach((player,index)=>{const video=player.querySelector("video");const transcript=player.querySelector(".video-transcript");if(video&&transcript){let transcriptId=transcript.id;if(!transcriptId){transcriptId=`video-transcript-${index+1}`;transcript.id=transcriptId;}
video.setAttribute("aria-describedby",transcriptId);const altText=video.getAttribute("alt")||video.getAttribute("aria-label")||"Video with transcript available.";video.setAttribute("aria-label",altText);video.setAttribute("alt",altText);if(!video.hasAttribute("tabindex")){video.setAttribute("tabindex","0");}}});});document.addEventListener("DOMContentLoaded",function(){const videoPlayers=document.querySelectorAll("video-player");videoPlayers.forEach((player,index)=>{const video=player.querySelector("video");const transcript=player.querySelector(".video-transcript");if(video&&transcript){let transcriptId=transcript.id;if(!transcriptId){transcriptId=`video-transcript-${index+1}`;transcript.id=transcriptId;}
video.setAttribute("aria-describedby",transcriptId);const altText=video.getAttribute("alt")||video.getAttribute("aria-label")||"Video with transcript available.";video.setAttribute("aria-label",altText);video.setAttribute("alt",altText);if(!video.hasAttribute("tabindex")){video.setAttribute("tabindex","0");}}});});document.addEventListener("DOMContentLoaded",function(){const videoPlayers=document.querySelectorAll("video-player");videoPlayers.forEach((player,index)=>{const video=player.querySelector("video");const transcript=player.querySelector(".video-transcript");if(video&&transcript){let transcriptId=transcript.id;if(!transcriptId){transcriptId=`video-transcript-${index+1}`;transcript.id=transcriptId;}
video.setAttribute("aria-describedby",transcriptId);const altText=video.getAttribute("alt")||video.getAttribute("aria-label")||"Video with transcript available.";video.setAttribute("aria-label",altText);video.setAttribute("alt",altText);if(!video.hasAttribute("tabindex")){video.setAttribute("tabindex","0");}}});});document.addEventListener("DOMContentLoaded",function(){const videoPlayers=document.querySelectorAll("video-player");videoPlayers.forEach((player,index)=>{const video=player.querySelector("video");const transcript=player.querySelector(".video-transcript");if(video&&transcript){let transcriptId=transcript.id;if(!transcriptId){transcriptId=`video-transcript-${index+1}`;transcript.id=transcriptId;}
video.setAttribute("aria-describedby",transcriptId);const altText=video.getAttribute("alt")||video.getAttribute("aria-label")||"Video with transcript available.";video.setAttribute("aria-label",altText);video.setAttribute("alt",altText);if(!video.hasAttribute("tabindex")){video.setAttribute("tabindex","0");}}});});document.querySelectorAll('.section-template--umc_freshcapvideo_tz3nzX video-player').forEach((video)=>{video.addEventListener('click',function(){document.querySelectorAll('.section-template--umc_freshcapvideo_tz3nzX video-player').forEach((ele)=>{if(video!=ele){ele.pauseAllVideo();}});});});
/* End Section umc_freshcapvideo_tz3nzX */
/* Start Section umc_freshcap_pdp_Q7LYhj */
function increaseQty(){const input=document.querySelector('[data-wwai-add-to-cart-quantity]');const current=parseInt(input.value,10)||1;input.value=current+1;}
function decreaseQty(){const input=document.querySelector('[data-wwai-add-to-cart-quantity]');const current=parseInt(input.value,10)||1;if(current>1){input.value=current-1;}}
document.addEventListener('DOMContentLoaded',function(){var Swipes=new Swiper('.section-template--umc_freshcap_pdp_Q7LYhj .review_wrapper.swiper',{loop:false,slidesPerView:1.6,spaceBetween:12,grabCursor:false,initialSlide:0,roundLengths:true,breakpoints:{768:{slidesPerView:3.01,centeredSlides:false,loop:false,initialSlide:0,spaceBetween:14,},},on:{init:function(){updateNavigationVisibility(this);},resize:function(){updateNavigationVisibility(this);},slideChange:function(){updateNavigationVisibility(this);},},});function updateNavigationVisibility(swiper){const totalSlides=swiper.slides.length;const slidesPerView=swiper.params.slidesPerView;const canShowAllSlides=totalSlides<=slidesPerView;const sliderControls=document.querySelector('.section-template--umc_freshcap_pdp_Q7LYhj .slider-controls');if(sliderControls){if(canShowAllSlides){sliderControls.style.display='none';}else{sliderControls.style.display='';}}}});document.addEventListener('DOMContentLoaded',function(){const productSection=document.querySelector('.section-template--umc_freshcap_pdp_Q7LYhj.product_fixed');const parentSection=document.querySelector('#shopify-section-template--umc_freshcap_pdp_Q7LYhj');window.addEventListener('scroll',(event)=>{let windowTop=Math.floor(window.scrollY);let parentTop=parentSection.offsetTop;let parentheight=parentSection.offsetHeight;if(windowTop<100){}else if(windowTop>parentTop&&windowTop<(parentTop+parentheight)){productSection.style.display='none';}else{productSection.style.display='block';}});});const openBtn=document.querySelector('.section-template--umc_freshcap_pdp_Q7LYhj .pdp_open_popup_text');const closeBtn=document.querySelector('.section-template--umc_freshcap_pdp_Q7LYhj .pdp_popup_close_btn');const popupOverlay=document.querySelector('.section-template--umc_freshcap_pdp_Q7LYhj .pdp_popup_overlay');openBtn.addEventListener('click',()=>{popupOverlay.style.display='flex';document.body.style.overflow='hidden';});closeBtn.addEventListener('click',()=>{popupOverlay.style.display='none';document.body.style.overflow='';});popupOverlay.addEventListener('click',(e)=>{if(e.target===popupOverlay){popupOverlay.style.display='none';document.body.style.overflow='';}});
/* End Section umc_freshcap_pdp_Q7LYhj */
/* Start Section umc_freshcapreviews_DMPbr6 */
document.addEventListener('DOMContentLoaded',function(){var Swipes=new Swiper('.section-template--umc_freshcapreviews_DMPbr6 .swiper',{loop:false,slidesPerView:1,spaceBetween:40,grabCursor:false,initialSlide:0,roundLengths:true,navigation:{nextEl:'.section-template--umc_freshcapreviews_DMPbr6 .next',prevEl:'.section-template--umc_freshcapreviews_DMPbr6 .prev',clickable:true,},breakpoints:{768:{slidesPerView:2,centeredSlides:false,loop:false,initialSlide:0,spaceBetween:20,},1199:{slidesPerView:4,centeredSlides:false,loop:false,initialSlide:0,spaceBetween:20,},},on:{init:function(){updateNavigationVisibility(this);},resize:function(){updateNavigationVisibility(this);},slideChange:function(){updateNavigationVisibility(this);},},});function updateNavigationVisibility(swiper){const totalSlides=swiper.slides.length;const slidesPerView=swiper.params.slidesPerView;const canShowAllSlides=totalSlides<=slidesPerView;const sliderControls=document.querySelector('.section-template--umc_freshcapreviews_DMPbr6 .slider-controls');if(canShowAllSlides){sliderControls.style.display='none';}else{sliderControls.style.display='';}}});
/* End Section umc_freshcapreviews_DMPbr6 */
document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth'
            });
        });
    });
});
(function () {
  // Check if the custom element is already defined
  if (!customElements.get('video-player')) {
    class VideoPlayer extends HTMLElement {
      constructor() {
        super();
        this.videos = this.querySelectorAll('video');
        this.videoWeb = this.videos[0];
        this.videoMob = this.videos[1];
        this.playBtn = this.querySelector('.play-btn');
        this.soundBtn = this.querySelector('.mute-btn');
        this.disableClick = this.dataset.click;

        if (this.disableClick) {
          this.initEventListeners();
        }
      }

      initEventListeners() {
        this.videos.forEach(video => {
          video.addEventListener('click', () => this.togglePlay(video));
          video.addEventListener('ended', () => this.handleVideoEnded(video));
        });

        if (this.playBtn) {
          this.playBtn.addEventListener('click', () => this.handlePlayButton());
        }

        if (this.soundBtn) {
          this.soundBtn.addEventListener('click', () => this.toggleMute());
        }

        window.addEventListener('resize', () => this.handleResize());
      }

      togglePlay(video) {
        if (video.paused) {
          this.playVideo(video);
        } else {
          this.pauseVideo(video);
        }
      }

      playVideo(video) {
        this.videos.forEach(otherVideo => {
          if (otherVideo !== video) {
            otherVideo.pause();
            otherVideo.muted = true;
          }
        });

        video.muted = false;
        video.play();
        this.classList.add('played');

        // ✅ Hide the Play button
        if (this.playBtn) {
          this.playBtn.style.opacity = '0';
          this.playBtn.style.pointerEvents = 'none'; // Prevent clicking while hidden
        }

        if (this.soundBtn) {
          this.soundBtn.classList.remove('active');
        }
      }

      pauseVideo(video) {
        video.pause();
        video.muted = true;
        this.classList.remove('played');

        // ✅ Show the Play button again
        if (this.playBtn) {
          this.playBtn.style.opacity = '1';
          this.playBtn.style.pointerEvents = 'auto';
        }

        if (this.soundBtn) {
          this.soundBtn.classList.add('active');
        }
      }
      pauseAllVideo() {
        this.videos.forEach(video => {
          this.pauseVideo(video)
        });
      }

      handlePlayButton() {
        const targetVideo = window.innerWidth < 749 && this.videoMob ? this.videoMob : this.videoWeb;
        if (targetVideo) this.togglePlay(targetVideo);
      }

      toggleMute() {
        const targetVideo = window.innerWidth < 749 && this.videoMob ? this.videoMob : this.videoWeb;
        if (targetVideo) {
          targetVideo.muted = !targetVideo.muted;
          this.soundBtn.classList.toggle('active', targetVideo.muted);
        }
      }

      handleResize() {
        if (!this.videoMob) return;

        const isMobile = window.innerWidth < 749;
        const targetVideo = isMobile ? this.videoMob : this.videoWeb;

        this.videos.forEach(video => {
          video.pause();
          video.muted = true;
        });

        targetVideo.play();
        targetVideo.muted = false;
        targetVideo.pause();
      }

      handleVideoEnded(video) {
        if (!video.loop) {
          this.classList.remove('played');
          video.muted = true;

          // ✅ Show the Play button again
          if (this.playBtn) {
            this.playBtn.style.opacity = '1';
            this.playBtn.style.pointerEvents = 'auto';
          }
        }
      }
    }

    // Define the custom element
    customElements.define('video-player', VideoPlayer);
  }
})();
if (!customElements.get('carousel-slider')) {
  class CarouselSlider extends HTMLElement {
    constructor() {
      super();
      this.activeIndex = 0;
      this.has_pre_injected_media = false;
      
      // DEBUG: Log constructor
      console.log('🚀 CarouselSlider constructor - activeIndex initialized to:', this.activeIndex);
    }

    connectedCallback() {
      console.log('🔌 CarouselSlider connectedCallback - activeIndex:', this.activeIndex);
      this.init();
      
      // If a selected media is pre-injected, set that in has_pre_injected_media.
      // In that case, in gotoSlide, we will use index + 1.
      const selectedMediaEl = this.mainMedia.querySelector('[data-wwai-selected-variant-product-media]');
      if (selectedMediaEl) {
        this.has_pre_injected_media = true;
        console.log('📽️ Pre-injected media found, has_pre_injected_media set to true');
      }
    }

    init() {
      console.log('⚡ CarouselSlider init - activeIndex:', this.activeIndex);
      this.cacheElements();
      this.bindEvents();
      // We dont perform scroll here, since either we have 
      // pre injected media or we will use index = 0 or we will call gotoSlide from 
      // functionality generator.
      // this.scrollToMediaItem(this.activeIndex);
    }

    cacheElements() {
      this.mainMedia = this.querySelector('main-slider');
      this.thumbSlider = this.querySelector('thumb-slider');
      this.thumbVertical = this.thumbSlider?.dataset.vartical;
      this.pagenation = this.querySelector('pagenation');
      this.mediaItems = this.mainMedia?.querySelectorAll('main-slider-slide') || [];
      this.thumbItems = this.thumbSlider?.querySelectorAll('thumb-slider-slide') || [];
      this.pageItems = this.pagenation?.querySelectorAll('button.page-media-item') || [];
      
      console.log('📦 Elements cached:');
      console.log('   - mediaItems.length:', this.mediaItems.length);
      console.log('   - thumbItems.length:', this.thumbItems.length);
      console.log('   - pageItems.length:', this.pageItems.length);
      console.log('   - activeIndex:', this.activeIndex);
    }

    bindEvents() {
      const mediaBtnNext = this.querySelector('.media-next');
      const mediaBtnPrev = this.querySelector('.media-prev');

      mediaBtnNext?.addEventListener('click', () => {
        console.log('➡️ Next button clicked - current activeIndex:', this.activeIndex);
        this.goToNext();
      });
      mediaBtnPrev?.addEventListener('click', () => {
        console.log('⬅️ Prev button clicked - current activeIndex:', this.activeIndex);
        this.goToPrev();
      });

      // Only add thumbnail event listeners if thumbItems exist
      if (this.thumbItems && this.thumbItems.length > 0) {
        this.thumbItems.forEach((thumb, index) => {
          thumb.addEventListener('click', () => {
            console.log('👆 Thumbnail clicked - index:', index, 'current activeIndex:', this.activeIndex);
            this.scrollToMediaItem(index);
          });
        });
      }
    
      this.pageItems.forEach((page, index) => {
        page.addEventListener('click', () => {
          console.log('📄 Page button clicked - index:', index, 'current activeIndex:', this.activeIndex);
          this.scrollToMediaItem(index);
        });
      });
    
      let scrollTimeout = null;
      this.mainMedia?.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          console.log('📜 Scroll detected - calling handleScrollSnap, current activeIndex:', this.activeIndex);
          this.handleScrollSnap();
        }, 200);
      });
    
      const updateThumbSliderHeight = () => {
        if (this.thumbSlider && this.thumbVertical && window.innerWidth > 768) {
          this.thumbSlider.style.maxHeight = this.mainMedia.offsetHeight + 'px';
        } else if (this.thumbSlider) {
          this.thumbSlider.style.maxHeight = '';
        }
      };
      
      setTimeout(updateThumbSliderHeight, 200);
      
      window.addEventListener('resize', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(updateThumbSliderHeight, 200);
      });
    }

    handleScrollSnap() {
      console.log('🎯 handleScrollSnap called - current activeIndex:', this.activeIndex, 'mediaItems.length:', this.mediaItems.length);
      
      const scrollLeft = this.mainMedia.scrollLeft;
      const itemWidth = this.mediaItems[0]?.clientWidth || 0;
      const offset = scrollLeft + this.mainMedia.offsetLeft;

      console.log('📏 Scroll measurements:', { scrollLeft, itemWidth, offset });

      let closestIndex = 0;
      let minDiff = Infinity;
      this.mediaItems.forEach((item, i) => {
        const diff = Math.abs(item.offsetLeft - offset);
        if (diff < minDiff) {
          minDiff = diff;
          closestIndex = i;
        }
      });

      console.log('🔍 Closest index calculated:', closestIndex, 'minDiff:', minDiff);
      this.scrollToMediaItem(closestIndex);
    }

    goToNext() {
      console.log('➡️ goToNext called - current activeIndex:', this.activeIndex, 'max index:', this.mediaItems.length - 1);
      
      if (this.activeIndex < this.mediaItems.length - 1) {
        const newIndex = this.activeIndex + 1;
        console.log('➡️ Moving to next slide:', newIndex);
        this.scrollToMediaItem(newIndex);
      } else {
        console.log('➡️ Already at last slide, cannot go next');
      }
    }

    goToPrev() {
      console.log('⬅️ goToPrev called - current activeIndex:', this.activeIndex);
      
      if (this.activeIndex > 0) {
        const newIndex = this.activeIndex - 1;
        console.log('⬅️ Moving to previous slide:', newIndex);
        this.scrollToMediaItem(newIndex);
      } else {
        console.log('⬅️ Already at first slide, cannot go previous');
      }
    }

    scrollToMediaItem(index) {
      console.log('🎬 scrollToMediaItem called with index:', index);
      console.log('🎬 Current state - activeIndex:', this.activeIndex, 'mediaItems.length:', this.mediaItems.length);
      console.log('🎬 Index validation - requested:', index, 'valid range: 0 to', this.mediaItems.length - 1);
      
      if (!this.mediaItems.length) {
        console.log('❌ No media items found, returning early');
        return;
      }

      // VALIDATION: Check if the requested index is valid
      if (index < 0 || index >= this.mediaItems.length) {
        console.error('❌ Invalid index requested:', index, 'Valid range: 0 to', this.mediaItems.length - 1);
        console.error('❌ Stacktrace:', new Error().stack);
        return; // Exit early to prevent the error
      }
    
      // Log current state before changes
      console.log('🔄 Removing active class from current activeIndex:', this.activeIndex);
      this.mediaItems[this.activeIndex]?.classList.remove('active');
      this.thumbItems[this.activeIndex]?.classList.remove('active');
      this.pageItems[this.activeIndex]?.classList.remove('active');
      
      const video_player = this.mediaItems[this.activeIndex]?.querySelector('video-player');
      
      // UPDATE activeIndex - This is where the critical change happens
      const oldIndex = this.activeIndex;
      this.activeIndex = index;
      console.log('🎯 activeIndex CHANGED from', oldIndex, 'to', this.activeIndex);
      
      if (video_player) {
        video_player.pauseAllVideo();
      }
    
      // Validate the new activeIndex before using it
      if (this.activeIndex >= this.mediaItems.length) {
        console.error('❌ CRITICAL: activeIndex', this.activeIndex, 'exceeds mediaItems.length', this.mediaItems.length);
        console.error('❌ This will cause the offsetLeft error!');
        return;
      }

      console.log('✅ Adding active class to new activeIndex:', this.activeIndex);
      this.mediaItems[this.activeIndex]?.classList.add('active');
      this.thumbItems[this.activeIndex]?.classList.add('active');
      this.pageItems[this.activeIndex]?.classList.add('active');
      
      console.log("this.mediaItems", this.mediaItems);
      console.log("this.activeIndex", this.activeIndex);
      console.log("the actual item,", this.mediaItems[this.activeIndex]);

      // This is where the error occurs - add extra validation
      const targetItem = this.mediaItems[this.activeIndex];
      if (!targetItem) {
        console.error('❌ CRITICAL: targetItem is undefined for activeIndex:', this.activeIndex);
        console.error('❌ mediaItems array:', Array.from(this.mediaItems));
        return;
      }

      console.log('📐 Calculating scroll position for activeIndex:', this.activeIndex);
      const scrollLeft = targetItem.offsetLeft - this.mainMedia.offsetLeft;
      console.log('📐 Scroll calculation - targetItem.offsetLeft:', targetItem.offsetLeft, 'mainMedia.offsetLeft:', this.mainMedia.offsetLeft, 'scrollLeft:', scrollLeft);
      
      this.mainMedia.scrollTo({ left: scrollLeft, behavior: 'smooth' });

      try {
          if (this.thumbSlider && this.thumbVertical && window.innerWidth > 768) {
            const thumbItem = this.thumbItems[this.activeIndex];
            if (thumbItem) {
              const thumbScroll = thumbItem.offsetTop - this.thumbSlider.offsetTop - ((this.thumbSlider.clientHeight / 2) - (thumbItem.clientHeight / 2));
              console.log('📐 Vertical thumb scroll calculation:', thumbScroll);
              this.thumbSlider.scrollTo({ top: thumbScroll, behavior: 'smooth' });
            } else {
              console.log('⚠️ No thumb item found for vertical scroll at index:', this.activeIndex);
            }
          } else if (this.thumbSlider) {
            const thumbItem = this.thumbItems[this.activeIndex];
            if (thumbItem) {
              const thumbScroll = thumbItem.offsetLeft - this.thumbSlider.offsetLeft - ((this.thumbSlider.clientWidth / 2) - (thumbItem.clientWidth / 2));
              console.log('📐 Horizontal thumb scroll calculation:', thumbScroll);
              this.thumbSlider.scrollTo({ left: thumbScroll, behavior: 'smooth' });
            } else {
              console.log('⚠️ No thumb item found for horizontal scroll at index:', this.activeIndex);
            }
          }
        } catch (error) {
          console.log('error in thumb scroll', error);
        }
    }

    refresh(index = 0) {
      console.log('🔄 refresh called with index:', index, 'current activeIndex:', this.activeIndex);
      this.activeIndex = index;
      console.log('🔄 activeIndex set to:', this.activeIndex, 'in refresh method');
      this.cacheElements();
      this.bindEvents();
    }

    createCustomCarouselSlide(data, isThumbnail = false) {
      console.log('🎨 createCustomCarouselSlide called for', isThumbnail ? 'thumbnail' : 'main', 'slide with data:', data);
      
      const slideTag = isThumbnail ? 'thumb-slider-slide' : 'main-slider-slide';
      const slideClass = isThumbnail ? 'thumb-media-item' : 'main-media-item';
      const slide = document.createElement(slideTag);
      slide.className = slideClass;
      slide.id = isThumbnail ? undefined : `wwai-media-${data.id}`;
  
      const img = document.createElement('img');
      img.src = isThumbnail ? `${data.src}&width=${data.width}` : data.src;
      img.alt = data.alt || "Image";
      img.width = data.width;
      img.height = data.height;
      img.loading = 'lazy';
      img.className = isThumbnail ? 'thumb-media-img' : 'main-media-img';
  
      const srcset = isThumbnail
        ? `${data.src}&width=${data.width} ${data.width}w`
        : [
            `${data.src}&width=352 352w`,
            `${data.src}&width=832 832w`,
            `${data.src}&width=1200 1200w`,
            `${data.src}&width=1920 1920w`,
            `${data.src}&width=2561 2561w`
          ].join(', ');
  
      img.setAttribute('srcset', srcset);
      img.setAttribute('sizes', '(min-width: 1536px) 1500px,(min-width: 1280px) 1250px,(min-width: 768px) 994px,(min-width: 768px) 708px,(min-width: 640px) 610px,100vw');
  
      if (isThumbnail) {
        slide.setAttribute('data-handle', `media-${data.id}`);
        slide.setAttribute('data-img-id', data.src);
      }
  
      slide.appendChild(img);
      return slide;
    }

    gotoSlide(index) {
      console.log('🎯 gotoSlide called with index:', index);
      console.log('🎯 Current state - activeIndex:', this.activeIndex, 'mediaItems.length:', this.mediaItems.length, 'has_pre_injected_media:', this.has_pre_injected_media);
      
      if (!this.mediaItems.length) {
        console.log('❌ No media items found in gotoSlide, returning early');
        return;
      }

      // We need to make sure that we use custom media config in functionality.
      // we can improve this by making clear slide not delete the pre injected media.
      let index_to_use = index;
      if (this.has_pre_injected_media) {
        index_to_use = index + 1;
        console.log('📽️ Pre-injected media detected, adjusting index from', index, 'to', index_to_use);
      }

      if (index_to_use < 0) {
        const resolvedIndex = this.mediaItems.length + index_to_use;
        console.log('⬅️ Negative index detected, resolving to:', resolvedIndex);
        this.scrollToMediaItem(resolvedIndex);
      } else {
        console.log('➡️ Using index:', index_to_use);
        this.scrollToMediaItem(index_to_use);
      }
    }

    clearSlides() {
      console.log('🧹 clearSlides called - clearing all media items');
      console.log('🧹 Before clearing - mediaItems.length:', this.mediaItems.length, 'activeIndex:', this.activeIndex);
      
      this.mainMedia.innerHTML = '';
      if (this.thumbSlider) {
        this.thumbSlider.innerHTML = '';
      }
      this.mediaItems = [];
      this.thumbItems = [];
      
      const oldIndex = this.activeIndex;
      this.activeIndex = 0;
      console.log('🧹 activeIndex reset from', oldIndex, 'to', this.activeIndex);
      console.log('🧹 After clearing - mediaItems.length:', this.mediaItems.length);
    }
  }
  
  customElements.define('carousel-slider', CarouselSlider);
}

const reviewButton = document.querySelector('.pdp_popup_cta');
const reviewsSection = document.querySelector('.yotpo-widget-instance');

// Add click event listener to the review button
reviewButton.addEventListener('click', function(e) {
    e.preventDefault(); // Prevent default link behavior
    
    // Close the popup
    if (popupOverlay) {
        popupOverlay.style.display = 'none';
        document.body.style.overflow = '';
    }
    
    // Scroll to reviews section
    if (reviewsSection) {
        reviewsSection.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }
});

// Alternative approach if you want to modify the existing href behavior:
// Remove the href attribute and add the event listener
reviewButton.removeAttribute('href');
reviewButton.style.cursor = 'pointer';
reviewButton.removeAttribute('target');

document.addEventListener("DOMContentLoaded", function () {
  const overlay = document.querySelector(".pdp_popup_overlay");
  const header = document.querySelector("header");
  if (overlay && header) {
    const wrapperDiv = document.createElement("div");
    wrapperDiv.className = "wwai_sections_container";
    const wrapperSection = document.createElement("section");
    wrapperSection.className = "section-template--umc_freshcap_pdp_Q7LYhj";
    wrapperSection.appendChild(overlay);
    wrapperDiv.appendChild(wrapperSection);
    header.insertAdjacentElement("afterend", wrapperDiv);
  }
});
